// StatusPill — Phase 4 Plan 04-03 (DIS-05).
//
// Renders driver status as a colored pill per DRIVER_STATUS_COLORS tokens.

import type { DriverStatus } from "../api/drivers";
import { DRIVER_STATUS_COLORS } from "../lib/tokens";

export interface StatusPillProps {
  status: DriverStatus;
  label?: string;
}

const STATUS_TO_KEY: Record<DriverStatus, keyof typeof DRIVER_STATUS_COLORS> = {
  online: "online",
  offline: "offline",
  on_trip: "activeTrip",
};

export function StatusPill({ status, label }: StatusPillProps): React.JSX.Element {
  const key = STATUS_TO_KEY[status];
  const palette = DRIVER_STATUS_COLORS[key];
  return (
    <span
      data-testid={`status-pill-${status}`}
      style={{
        display: "inline-block",
        padding: "4px 10px",
        borderRadius: 12,
        backgroundColor: palette.bg,
        color: palette.text,
        fontSize: 12,
        fontWeight: 600,
        textTransform: "capitalize",
      }}
    >
      {label ?? status.replace("_", " ")}
    </span>
  );
}
